var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":""}},[_vm._v("Input Redeem code")]),_c('input',{attrs:{"type":"text"}}),_c('button',{on:{"click":_vm.redeemTicket}},[_vm._v("Redeem")]),(_vm.codeVerified)?_c('img',{attrs:{"src":_vm.imageURL}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }